import React, { useEffect, useState } from "react";

import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading } from "../zustand/store.js";

import * as APIS from '../utils/service.js'

import { LangText } from "../zustand/dict.js";
// import { lang } from '../utils/utils';
import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";
import { useLocation, useNavigate } from "react-router-dom";
import { getSlideValue, loadImage, toSlideValue } from "../utils/utils.js";
import Modal from "../components/Modal.js";

/*
이미지 편집하기
*/
export default function Menu4() {
    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();
    const [modal, setModal] = useState(consts.defaultModalValue)

    const [config, setConifg] = useState({});
    const [photo, setphoto] = useState(null);
    const [prompt, setPrompt] = useState("");
    const [seed, setSeed] = useState("");
    const [selSampler, setselSampler] = useState(0);
    const [styleIndex, setStyleIndex] = useState(0);
    const [styleType, setStyleType] = useState(0);
    const [isStyleUpload, setIsStyleUpload] = useState(false);
    const [styleFile, setStyleFile] = useState(null);
    const [negaPrompt, setNegaPrompt] = useState(""); //네거티브 프롬프트
    const [moreView, setMoreView] = useState(false)

    const [slide1, setSlide1] = useState(50);
    const [slide2, setSlide2] = useState(50);
    const [slide3, setSlide3] = useState(50);

    const [share, setShare] = useState(false);

    const [configError, setConfigError] = useState(false);

    // 설정값 불러오기
    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    // 기본값 설정
    const defaultSetOption = (configData) => {
        let error = false

        if ("option_selector_contents" in configData) {
            setStyleType(configData.option_selector_contents[0].idx)
        } else {
            error = true
        }

        if ("option_image_style" in configData) {
            setStyleIndex(0)
        } else {
            error = true
        }

        if ("option_selector_sampler" in configData) {
            setselSampler(configData.option_selector_sampler[0].idx)
        } else {
            error = true
        }

        if ("option_slide" in configData) {
            setSlide1(configData.option_slide.workPhoto?.default)
            setSlide2(configData.option_slide.style?.default)
            setSlide3(configData.option_slide.step?.default)
        } else {
            error = true
        }

        if (error) setConfigError(error)

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.photoFile) {
            let imageData = await loadImage(consts.imgUrl + artData?.photoFile)
            setphoto(imageData)
        }

        if (artData?.negativePrompt) {
            setNegaPrompt(artData?.negativePrompt)
        }

        if (artData?.contentType) {
            let data = configData?.option_selector_contents?.find(v => v.value == artData?.contentType)
            console.log("🚀 ~ setLoadFunc ~ data:", data)
            if (data) {
                setStyleType(data.idx);
            }
        }

        if (artData?.imageStyle) {
            let dataIndex = configData?.option_image_style?.findIndex(v => v.value == artData?.imageStyle)
            console.log("🚀 ~ setLoadFunc ~ dataIndex:", dataIndex)
            if (dataIndex >= 0) {
                setStyleIndex(dataIndex)
            }
        } else if (artData?.imageStyleFile) {
            setIsStyleUpload(true);
            let imageData = await loadImage(consts.imgUrl + artData?.imageStyleFile)
            setStyleFile(imageData)
        }

        if (artData?.seed) {
            setSeed(artData?.seed)
        }

        if (artData?.sampler) {
            let data = configData?.option_selector_sampler?.find(v => v.value == artData?.sampler)
            if (data) {
                setselSampler(data.idx);
            }
        }

        if (typeof artData?.photoStrength == "number") {
            setSlide1(artData?.photoStrength)
        }

        if (typeof artData?.styleStrength == "number") {
            setSlide2(artData?.styleStrength)
        }

        if (typeof artData?.step == "number") {
            setSlide3(artData?.step)
        }
    }

    // 만들기
    const makeImageFunc = () => {
        // navigate("/myart_history");
        let sendData = {
            photo: photo,
            contentType: styleType,
            sampler: selSampler,
            imageStyle: 0,
            photoStrength: 0,
            styleStrength: 0,
            step: 50,
            seed: seed,
            prompt: prompt,
            negativePrompt: negaPrompt,
            share: !share
        }


        if (!photo) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_photo" })
            })
            return;
        }

        if (isStyleUpload) { //스타일 설정
            console.log("🚀 ~ makeImageFunc ~ isStyleUpload:", isStyleUpload)
            if (!styleFile) {
                setModal({
                    ...modal,
                    open: true,
                    message: getLang({ key: "error_input_style" })
                })
                return;
            }
            sendData.imageStyle = styleFile
        } else {
            sendData.imageStyle = config.option_image_style[styleIndex].idx
        }

        sendData.photoStrength = Number(slide1)
        sendData.styleStrength = Number(slide2)
        sendData.step = Number(slide3)

        // console.log("🚀 ~ makeImageFunc ~ sendData:", sendData)
        // return;
        APIS.post("/aiImage/edit", sendData).then(({ data }) => {
            if (data) console.log("/aiImage/avatar:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            console.log(data, getLang({ key: data.msgkey }));
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    useEffect(() => {
        configDataFunc();
    }, [])

    const modalConfirm = () => {
        modalClose();
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 4 }).title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 4 }).info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        {/* <img src={consts.imgUrl + getMenu({ idx: 4 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 4 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_work_image" /></p>
                                <p className="body1"><LangText id="info_upload_work_image" /></p>
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            value={photo}
                            setValue={setphoto}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_content_type" /></p>
                            </div>
                        </div>
                        <Radio
                            value={styleType}
                            setValue={setStyleType}
                            options={config?.option_selector_contents?.map((v, i) => {
                                return { value: v.idx, label: getLang({ key: v.title_key }) }
                            })} />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_set_image_style" /></p>
                                <p className="body1"><LangText id="info_image_style" /></p>
                            </div>

                            <Button title={isStyleUpload ? "스타일 목록 보기" : "스타일 이미지 업로드하기"} type={2} onClick={() => {
                                setIsStyleUpload(!isStyleUpload)
                            }} />
                        </div>
                        {!isStyleUpload ? <div className="border_box">
                            <p className="body1">스타일 목록</p>
                            <RadioImage
                                className="mt-12"
                                options={config?.option_image_style?.map((v) => {
                                    return { title: getLang({ key: v?.title_key }), imgSrc: `${consts.imgUrl}${v?.imgPath}` }
                                })}
                                current={styleIndex}
                                onChange={setStyleIndex}
                            />
                        </div> : <InputFileDrag
                            name="drag-file-style"
                            value={styleFile}
                            setValue={setStyleFile}
                        />}

                    </div>
                    {/* ------------------- more section ---------------------- */}

                    {moreView && <>
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_set_seed" /></p>
                                    <p className="body1">
                                        <LangText id="info_set_seed1" />
                                        <span className="color-sec"><LangText id="info_set_seed2" /></span>
                                    </p>
                                </div>
                            </div>

                            <InputSimple
                                style
                                valid="num"
                                value={seed}
                                setValue={setSeed}
                                placeholder={getLang({ key: "placeholder_seed" })}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_sampler_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_sampler_set1" />
                                        <span className="color-sec"><LangText id="info_sampler_set2" /></span>
                                    </p>
                                </div>

                            </div>
                            <div
                                style={{ display: "flex", minWidth: 210 }}
                                className="sel_box">
                                <Selector
                                    options={config?.option_selector_sampler?.map(v => {
                                        return { value: v?.idx, label: getLang({ key: v?.title_key }) }
                                    })}
                                    value={selSampler}
                                    setValue={setselSampler}
                                />
                            </div>
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_work_ref_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_work_ref_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_str_min" })}
                                endText={getLang({ key: "text_str_max" })}
                                step={config.option_slide?.workPhoto?.step}
                                min={config.option_slide?.workPhoto?.min || 0}
                                max={config.option_slide?.workPhoto?.max || 100}
                                value={slide1}
                                setValue={setSlide1}
                                tickerValue={slide1}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_work_prompt" /></p>
                                    <p className="body1"><LangText id="info_work_prompt" /></p>
                                </div>
                            </div>

                            <InputSimple
                                style
                                value={prompt}
                                setValue={setPrompt}
                                placeholder={"a man drawn like the starry night style"}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_negative_propmt" /></p>
                                    <p className="body1">
                                        <LangText id="info_negative_propmt" />
                                    </p>
                                </div>
                            </div>

                            <InputSimple
                                value={negaPrompt}
                                setValue={setNegaPrompt}
                                placeholder={getLang({ key: "info_negative_propmt" })}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_style_ref_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_style_ref_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_str_min" })}
                                endText={getLang({ key: "text_str_max" })}
                                step={config.option_slide?.style?.step}
                                min={config.option_slide?.style?.min || 0}
                                max={config.option_slide?.style?.max || 100}
                                value={slide2}
                                setValue={setSlide2}
                                tickerValue={slide2}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_step_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_stop_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_fast_create" })}
                                endText={getLang({ key: "text_high_quality" })}
                                step={config.option_slide?.step?.step}
                                min={config.option_slide?.step?.min || 0}
                                max={config.option_slide?.step?.max || 100}
                                value={slide3}
                                setValue={setSlide3}
                                tickerValue={slide3}
                            />
                        </div>
                    </>}


                    {/* ------------------- more section ---------------------- */}

                    <div className="more_box" >
                        <div className="btn_box"
                            onClick={() => {
                                setMoreView(!moreView)
                            }}>
                            <p className={`title${moreView ? " focus" : ""}`}><LangText id="text_more_option" /></p>
                        </div>
                    </div>
                </div>

                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_image", replace: { key: "{0}", val: getMenu({ idx: 4 })?.point } })}
                        round
                        onClick={makeImageFunc}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        // checked={false}
                        onChange={(e) => {
                            console.log(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
